import React, { useState } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/system';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { ArrowRight } from 'react-feather';

const RegionItem = ({ imageUrl, name, description, last, newsId, date }) => {
    const [isHover, setHover] = useState(false);

    const { t } = useTranslation();

    const handleMouseEnter = (e) => {
        setHover(true);
    };

    const handleMouseLeave = () => {
        setHover(false);
    };

    return (
        <Box
            className={`cursor-pointer relative`}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            <Link href={'/region/' + newsId} passHref>
                <Box
                    style={{
                        height: '230px',
                        overflow: 'hidden',
                        borderRadius: 10,
                        position: 'relative',
                    }}
                >
                    <Box
                        style={{
                            // position: 'relative',
                            // width: '430px',
                            // backgroundImage: 'url(/banner.jpg)',
                            width: '100%',
                            height: '100%',
                            backgroundImage: `url(${imageUrl})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            transform: isHover ? 'scale(1.06)' : 'none',
                            transition:
                                'margin-bottom 0.3s ease-in-out, margin-top 0.3s ease-in-out, height 0.3s ease-in-out, box-shadow 0.3s ease-in-out, transform 0.5s ease-in-out',
                        }}
                    ></Box>

                    <Typography
                        variant="subtitle3"
                        className="absolute"
                        style={{
                            color: 'white',
                            backgroundColor: '#3a3973',
                            top: 30,
                            left: 0,
                            padding: '8px 15px',
                            fontSize: 14,
                        }}
                    >
                        {date}
                    </Typography>
                </Box>
            </Link>
            <Link href={'/region/' + newsId} passHref>
                <Box
                    style={{
                        boxShadow: '0 0 30px rgba(31, 45, 61, 0.125)',
                        borderRadius: 5,
                        backgroundColor: '#fff',
                        padding: 15,
                        margin: '-30px 20px 0',
                        position: 'relative',
                    }}
                >
                    <Typography variant="h3" className="font-bold text-center">
                        {name}
                    </Typography>
                    <Box className="flex flex-row justify-center items-center">
                        <Typography
                            variant="body2"
                            className=" text-center py-5 mr-1"
                            style={{ color: '#fe4f6c' }}
                        >
                            {t('read_more')}
                        </Typography>

                        <ArrowRight color={'#fe4f6c'} size={'17'} />
                    </Box>
                    {/* <Typography variant="body2">{description}</Typography> */}
                </Box>
            </Link>
        </Box>
    );
};

export default RegionItem;
